import { render, staticRenderFns } from "./UrgentGetOffPop.vue?vue&type=template&id=17720ce3"
import script from "./UrgentGetOffPop.vue?vue&type=script&lang=js"
export * from "./UrgentGetOffPop.vue?vue&type=script&lang=js"
import style0 from "./UrgentGetOffPop.vue?vue&type=style&index=0&id=17720ce3&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17720ce3')) {
      api.createRecord('17720ce3', component.options)
    } else {
      api.reload('17720ce3', component.options)
    }
    module.hot.accept("./UrgentGetOffPop.vue?vue&type=template&id=17720ce3", function () {
      api.rerender('17720ce3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/UrgentGetOffPop.vue"
export default component.exports